(function () {
  'use strict';

  /* @ngdoc object
   * @name applicationParameters
   * @description
   *
   */
  angular
    .module('applicationParameters', [
      'ui.router'
    ]);
}());
